:host {
	display: block;
}
:host smoothly-display {
	display: inline;
}
:host fake-cell-wrapper.span-2 {
	grid-column: span 2;
}
:host>smoothly-display {
	display: inherit;
	font-size: 2em;
}
:host>* {
	margin-bottom: 2rem;
}
/* Apply these styles to your element that is 
 * wrapping one of these table components
*/
:host fake-group-wrapper,
:host fake-row-wrapper,
:host fake-expandable-row-wrapper {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: subgrid;
}
:host fake-cell-wrapper {
	/*                ↓ This is the column span. only needed if span != 1 */
	grid-column: span 1;
	/* it can be any display that is not contents */
	display: block;
}
:host fake-expandable-cell-wrapper {
	display: contents;
}
